import {Injectable} from '@angular/core';
import {UtishaTheme} from './theme';


@Injectable({
  providedIn: 'root'
})
export class ThemingService {

  private themeInternal: UtishaTheme = UtishaTheme.STUDENT;

  constructor() {
  }

  get theme(): UtishaTheme {
    return this.themeInternal;
  }

  set theme(theme: UtishaTheme) {
    this.themeInternal = theme;
  }
}
